'use client';

import { ComponentProps, FC } from 'react';
import { useFormStatus } from 'react-dom';
import { Button } from './Button';

type Props = Prettify<Omit<ComponentProps<typeof Button>, 'onClick' | 'href' | 'isLoading' | 'type' | 'ref'>>;

/**
 * Submit button to be used within a form with action
 */
export const SubmitButton: FC<Props> = ({ children, ...props }) => {
  const { pending } = useFormStatus();
  return (
    <Button {...props} isLoading={pending} type="submit" name="submit" value="submit">
      {children}
    </Button>
  );
};
